<template>
  <div>

    <v-fab-transition>
      <v-btn
          class="but-class"
          bottom
          right
          fixed
          fab
          @click="show = true"
      >
        <v-badge :content="typeSelect.length" :value="typeSelect.length" :offset-y="-3">
          <span>
            分类
          </span>
        </v-badge>
      </v-btn>
    </v-fab-transition>


    <v-dialog v-model="show" max-width="600">
      <v-card class="pa-2">

        <div class="ma-2">
          <v-chip
              class="ma-1"
              v-for="(item,index) in typeList"
              :key="index"
              filter
              @click="add(item)"
          >
            <v-avatar left v-if="selectItem(item)">
              <v-icon>mdi-checkbox-marked-circle</v-icon>
            </v-avatar>
            {{ item.label }}
          </v-chip>
        </div>
        <v-card-actions>
          <v-btn
              text
              @click="show = false"
          >
            关闭
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
              text
              @click="reset"
          >
            重置
          </v-btn>
          <v-btn
              text
              @click="find"
          >
            查询
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>

export default {
  name: "imgTypeSelect",
  model: {
    props: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    typeList:{
      type:Array,
      default: () => [{"value": "Night", "label": "Night"}, {"value": "Film", "label": "电影"}, {
        "value": "Transportation",
        "label": "交通"
      }, {"value": "Food", "label": "美食"}, {"value": "People", "label": "人物"}, {
        "value": "Nature",
        "label": "自然"
      }, {"value": "Animals", "label": "动物"}, {"value": "Aerial", "label": "航空"}, {
        "value": "Celebrities",
        "label": "名人"
      }, {"value": "Fine+Art", "label": "艺术"}, {"value": "Commercial", "label": "商业"}, {
        "value": "Street",
        "label": "街景"
      }, {"value": "City+&+Architecture", "label": "城市与建筑"}, {
        "value": "Performing+Arts",
        "label": "表演艺术"
      }, {"value": "Wedding", "label": "婚礼"}, {"value": "Sport", "label": "运动"}, {
        "value": "Family",
        "label": "家庭"
      }, {"value": "Urban+Exploration", "label": "都市探奇"}, {"value": "Macro", "label": "微距"}, {
        "value": "Still+Life",
        "label": "静物"
      }, {"value": "Abstract", "label": "抽象"}, {"value": "Concert", "label": "音乐会"}, {
        "value": "Journalism",
        "label": "新闻"
      }, {"value": "Landscapes", "label": "风景"}, {"value": "Travel", "label": "旅行"}, {
        "value": "Black+and+White",
        "label": "黑白"
      }, {"value": "Fashion", "label": "时尚"}, {"value": "Uncategorized", "label": "未分类"}, {
        "value": "Underwater",
        "label": "水下"
      }]
    }
  },
  data: () => ({
    typeSelect: [],
    show: false,
  }),
  mounted() {
    this.typeSelect = [...this.value]
  },
  methods: {
    add({value}) {
      let index = this.typeSelect.findIndex(item => item === value)
      if (index === -1) {
        this.typeSelect.push(value)
      } else {
        this.typeSelect.splice(index, 1)
      }
    },
    reset() {
      this.typeSelect.splice(0, this.typeSelect.length)
    },
    selectItem({value}) {
      if (this.typeSelect.length === 0) return false
      return this.typeSelect.findIndex(item => item === value) !== -1
    },
    find() {
      this.show = false;
      this.$emit('change', [...this.typeSelect])
      this.$parent.imgList = []
      this.$parent._list();
    }
  }
}
</script>

<style scoped>
.but-class {
  bottom: 76px;
}
</style>
